var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309 737L309 765",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.5,
    cy: 732.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.083 737.222H310.917V733.917H314.222V731.083H310.917V727.778H308.083V731.083H304.778V733.917H308.083V737.222ZM302.889 741C302.369 741 301.925 740.815 301.555 740.445C301.185 740.075 301 739.631 301 739.111V725.889C301 725.369 301.185 724.925 301.555 724.555C301.925 724.185 302.369 724 302.889 724H316.111C316.631 724 317.075 724.185 317.445 724.555C317.815 724.925 318 725.369 318 725.889V739.111C318 739.631 317.815 740.075 317.445 740.445C317.075 740.815 316.631 741 316.111 741H302.889ZM302.889 739.111H316.111V725.889H302.889V739.111Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital1);
export default __webpack_public_path__ + "static/media/hospital_1.4fe7391cc99f097396b62238ccdde9d1.svg";
export { ForwardRef as ReactComponent };